<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">会员卡促销</div>

    <!-- 查询条件 -->
    <div class="search-wrapper">
      <el-form
        :inline="true"
        :model="queryParam"
        label-width="82px"
        class="search-row"
      >
        <el-form-item label="适用会员卡">
          <el-select
            v-model="queryParam.cardId"
            style="width: 220px"
            clearable
            placeholder="全部"
          >
            <el-option label="全部" :value="0"></el-option>
            <el-option
              v-for="card in cardOptions"
              :key="card.id"
              :label="`${card.name}（ID:${card.id}）`"
              :value="card.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParam.status" style="width: 140px">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="未开始" :value="1"></el-option>
            <el-option label="进行中" :value="2"></el-option>
            <el-option label="已结束" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-action-item">
          <el-button @click="clickReset">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表上方汇总：累计销量 / 累计收入（来自 /adminapi/privilegePromotion/salesStatistics） -->
    <div class="summary-wrapper">
      <div class="summary-item">
        <span class="summary-label">累计销量</span>
        <span class="summary-value">{{
          summary.totalSales != null ? summary.totalSales : "--"
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">累计收入</span>
        <span class="summary-value">{{
          summary.totalIncome != null ? formatYuan(summary.totalIncome) : "--"
        }}</span>
      </div>
      <el-button class="summary-add-btn" type="primary" @click="clickCreateSale"
        >新增</el-button
      >
    </div>

    <div class="content-wrapper">
      <el-table ref="promotionTable" :data="listData" border>
        <el-table-column
          prop="id"
          label="活动ID"
          min-width="95"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="activityName"
          label="活动名称"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="促销时间" min-width="320">
          <template scope="{ row }">{{ row.promoTimeText }}</template>
        </el-table-column>
        <el-table-column label="适用会员卡" min-width="170">
          <template scope="{ row }"
            >{{ row.cardName }}（ID:{{ row.cardId }}）</template
          >
        </el-table-column>
        <el-table-column label="售卖价" min-width="110" align="center">
          <template scope="{ row }">{{ row.salePriceText }}</template>
        </el-table-column>
        <el-table-column label="活动限购" min-width="130" align="center">
          <template scope="{ row }">{{ row.purchaseLimitText }}</template>
        </el-table-column>
        <el-table-column label="适用人群" min-width="150">
          <template scope="{ row }">
            <div v-if="row.audiences && row.audiences.length">
              <div
                v-for="(aud, i) in row.audiences"
                :key="i"
                class="audience-line"
              >
                {{ aud }}
              </div>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="topTag"
          label="顶部标签"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="底部标签" min-width="150" show-overflow-tooltip>
          <template scope="{ row }">
            <span v-if="row.bottomTagType === 2">{{
              countdownText(row.endTime)
            }}</span>
            <span v-else>{{ row.bottomTag }}</span>
          </template>
        </el-table-column>
        <el-table-column label="促销价" min-width="150">
          <template scope="{ row }">
            <span>{{ row.promotionPriceText }}</span>
            <span v-if="row.discountText" class="discount-text">{{
              row.discountText
            }}</span>
          </template>
        </el-table-column>
        <!-- 活动销量/活动收入：接口暂无返回，待后端补齐统计逻辑 -->
        <el-table-column
          prop="salesCount"
          label="活动销量"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="salesRevenue"
          label="活动收入"
          min-width="130"
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" min-width="90" align="center">
          <template scope="{ row }">
            <el-tag :type="statusTagType(row.status)">{{
              row.statusText
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAtText"
          label="创建时间"
          min-width="170"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="280"
          align="center"
          fixed="right"
        >
          <template scope="{ row }">
            <el-button type="text" @click="clickView(row)">查看促销</el-button>
            <el-button type="text" @click="clickEdit(row)">编辑</el-button>
            <el-button type="text" @click="clickCopy(row)">复制</el-button>
            <el-button
              v-if="row.status !== 3"
              type="text"
              style="color: #f56c6c"
              @click="clickEnd(row)"
              >立即结束</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <div v-show="total > 0" class="pagination-seq">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="changeCurrentPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

// 会员卡促销活动后台管理 Controller（运营后台 Apifox，2026-08-12 确认）
// 接口前缀 /adminapi/privilegePromotion/：list(detail(add(endNow
// 实体 PrivilegePromotionModel：id, name, startTime, endTime, privilegeConfigId, limitType(1-不限制 2-限购1次), schemes[]
// 方案 PrivilegePromotionSchemeModel：crowdType(1新用户2老用户), crowdRule, topLabel,
//   bottomLabelType(1-文案 2-倒计时，未传默认1), bottomLabel(倒计时类型不返回),
//   promotionType(1价格2折扣), promotionValue(促销值), discountPrice(折后价,元,仅响应)
export default {
  data() {
    return {
      loading: false,
      queryParam: this.getDefaultQueryParam(),
      cardOptions: [], // 售卖卡下拉 { id, name }
      cardMap: {}, // id -> { name, price(分) } 用于反查名称与售卖价
      total: 0,
      listData: [],
      // 底部标签为「活动倒计时」时的实时读秒基准（每秒刷新）
      nowTick: Date.now(),
      countdownTimer: null,
      summary: {
        totalSales: null,
        totalIncome: null,
      },
      // 状态文案映射：1=未开始 2=进行中 3=已结束（与后端 runtimeStatus 一致）
      statusTextMap: { 1: "未开始", 2: "进行中", 3: "已结束" },
    };
  },

  mounted() {
    // 先拉会员卡下拉（回填 cardMap 用于回显卡名），再查列表，
    // 避免列表接口先返回时 cardMap 为空导致「适用会员卡」列全显示 "--"
    if (this.$route.query.id) {
      this.queryParam.cardId = +this.$route.query.id;
    }
    this.fetchCardOptions();
    this.queryList();
    // 列表上方「累计销量/累计收入」汇总（全局，无筛选参数，独立拉取）
    this.fetchSalesStatistics();
    // 底部标签倒计时读秒：每秒刷新一次基准时间
    this.startCountdownTimer();
  },

  beforeDestroy() {
    this.clearCountdownTimer();
  },

  methods: {
    startCountdownTimer() {
      this.clearCountdownTimer();
      this.nowTick = Date.now();
      this.countdownTimer = setInterval(() => {
        this.nowTick = Date.now();
      }, 1000);
    },

    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },

    // 底部标签倒计时：距活动结束时间「剩xx天 HH:mm:ss」（dayjs duration）
    countdownText(endTime) {
      if (!endTime) {
        return "--";
      }
      const end = dayjs(endTime).valueOf();
      if (isNaN(end)) {
        return "--";
      }
      const rest = Math.max(end - this.nowTick, 0);
      const d = dayjs.duration(rest);
      const pad = (n) => String(Math.floor(n)).padStart(2, "0");
      return `剩${Math.floor(d.asDays())}天 ${pad(d.hours())}:${pad(
        d.minutes()
      )}:${pad(d.seconds())}`;
    },
    getDefaultQueryParam() {
      return {
        pageNum: 1,
        pageSize: 20,
        cardId: 0, // 0=全部
        status: 0, // 0=全部
      };
    },

    // 适用会员卡下拉 + 反查 map：取“售卖卡”（type=1），展示 名称+卡ID
    // 返回字段：id, name, price(分), type(1售卖卡/2赠送卡)
    fetchCardOptions() {
      this.$http({
        url: this.$util.domain + "/adminapi/privilegeConfig/sellList",
        method: "GET",
      })
        .then((res) => {
          const models = (res.data && res.data.data) || [];
          this.cardOptions = models.map((c) => ({ id: c.id, name: c.name }));
          this.cardMap = {};
          this.cardOptions.forEach((c) => {
            this.$set(this.cardMap, c.id, { name: c.name, price: c.price });
          });
        })
        .catch(() => {
          this.cardOptions = [];
          this.cardMap = {};
        });
    },

    // 列表查询：GET /adminapi/privilegePromotion/list
    queryList() {
      this.loading = true;
      const params = {
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      };
      // cardId=0 / status=0 表示全部，不传后端筛选
      if (this.queryParam.cardId) {
        params.privilegeConfigId = this.queryParam.cardId;
      }
      if (this.queryParam.status) {
        params.runtimeStatus = this.queryParam.status;
      }
      this.$http({
        url: this.$util.domain + "/adminapi/privilegePromotion/list",
        method: "GET",
        params,
      })
        .then((res) => {
          const data = (res.data && res.data.data) || {};
          const models = data.models || [];
          this.listData = models.map(this.formatItem);
          this.total = data.total || 0;
          // 注：list 接口仅返回 total + models，汇总（累计销量/收入）由 salesStatistics 单独拉取
        })
        .catch(() => {
          this.listData = [];
          this.total = 0;
          this.summary = { totalSales: null, totalIncome: null };
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 状态：优先用后端 runtimeStatus（入参证明后端维护），缺失时回退前端时间推算
    getStatus(item) {
      if (item.runtimeStatus && [1, 2, 3].includes(item.runtimeStatus)) {
        return item.runtimeStatus;
      }
      return this.computeStatus(item);
    },

    computeStatus(item) {
      const now = Date.now();
      if (item.manualEnded) {
        return 3;
      }
      const start = item.startTime ? new Date(item.startTime).getTime() : NaN;
      const end = item.endTime ? new Date(item.endTime).getTime() : NaN;
      if (!isNaN(end) && end < now) {
        return 3;
      }
      if (!isNaN(start) && start > now) {
        return 1;
      }
      if (!isNaN(start) && !isNaN(end) && start <= now && end > now) {
        return 2;
      }
      return 2;
    },

    statusTagType(status) {
      return status === 2 ? "success" : status === 3 ? "warning" : "gray";
    },

    formatDateTime(value) {
      if (!value) {
        return "--";
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return String(value);
      }
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },

    // 金额：会员卡 price 单位为“分”，/100 展示为元
    formatPrice(value) {
      if (value === null || value === undefined || value === "") {
        return "--";
      }
      return "¥" + (Number(value) / 100).toFixed(2);
    },

    // 累计收入：salesStatistics 返回的 salesRevenue 已是“元”字符串（如 "392.21"），无需 /100
    formatYuan(value) {
      if (value === null || value === undefined || value === "") {
        return "--";
      }
      const n = Number(value);
      return "¥" + (isNaN(n) ? value : n.toFixed(2));
    },

    // 列表上方「累计销量/累计收入」汇总：GET /adminapi/privilegePromotion/salesStatistics
    // 无筛选参数，返回全部促销活动的全局累计值：
    //   data.salesVolume: integer 活动销量
    //   data.salesRevenue: string 活动收入（元，如 "392.21"）
    fetchSalesStatistics() {
      this.$http({
        url: this.$util.domain + "/adminapi/privilegePromotion/salesStatistics",
        method: "GET",
      })
        .then((res) => {
          const resp = res.data || {};
          if (resp.error === 10000) {
            const d = resp.data || {};
            this.summary = {
              totalSales: d.salesVolume != null ? d.salesVolume : null,
              totalIncome: d.salesRevenue != null ? d.salesRevenue : null,
            };
          } else {
            console.warn("[会员卡促销] salesStatistics 失败", resp);
          }
        })
        .catch((err) => {
          console.warn("[会员卡促销] salesStatistics 异常", err);
        });
    },

    // 促销价展示：折扣类型(2)展示 促销价+折扣；价格类型(1)只展示促销价
    // 注：scheme.promotionValue / discountPrice 文档未明确单位，按“元”直接展示（若后端返回分为请 /100）
    getPromotionText(schemes) {
      const s = schemes && schemes[0];
      if (!s) {
        return { priceText: "--", discountText: "" };
      }
      if (s.promotionType === 2) {
        const priceText =
          s.discountPrice != null
            ? "¥" + s.discountPrice
            : s.promotionValue != null
            ? "¥" + s.promotionValue
            : "--";
        const discountText =
          s.promotionValue != null ? s.promotionValue + "折" : "";
        return { priceText, discountText };
      }
      const priceText =
        s.promotionValue != null ? "¥" + s.promotionValue : "--";
      return { priceText, discountText: "" };
    },

    // 把后端活动实体映射为表格行视图模型
    formatItem(item) {
      const status = this.getStatus(item);
      const card = this.cardMap[item.privilegeConfigId] || {};
      const schemes = item.schemes || [];

      // 适用人群：逐 scheme 的 crowdRule（无文案时回退 crowdType 文案）
      const audiences = schemes
        .map(
          (s) =>
            s.crowdRule ||
            (s.crowdType === 1 ? "新用户" : s.crowdType === 2 ? "老用户" : "")
        )
        .filter(Boolean);

      // 顶部/底部标签：逐 scheme 聚合去重（接口在 scheme 级）
      const topLabels = [
        ...new Set(schemes.map((s) => s.topLabel).filter(Boolean)),
      ];
      const bottomLabels = [
        ...new Set(schemes.map((s) => s.bottomLabel).filter(Boolean)),
      ];
      // 底部标签类型：任一方案为倒计时(2)即按倒计时展示
      // （bottomLabelType 未传默认 1-文案；倒计时类型接口不返回 bottomLabel）
      const bottomTagType = schemes.some((s) => Number(s.bottomLabelType) === 2)
        ? 2
        : 1;

      const promo = this.getPromotionText(schemes);
      const salePrice = card.price != null ? card.price : null; // 分

      return {
        id: item.id,
        activityName: item.name,
        privilegeConfigId: item.privilegeConfigId,
        cardName: card.name || "--",
        cardId: item.privilegeConfigId,
        salePrice,
        salePriceText:
          item.privilegeConfigPrice != null
            ? "¥" + (item.privilegeConfigPrice / 100).toFixed(2)
            : "-",
        limitType: item.limitType,
        purchaseLimit: item.limitType === 2 ? 1 : 0,
        purchaseLimitText: item.limitType === 2 ? "每个用户限购1次" : "不限制",
        startTime: item.startTime,
        endTime: item.endTime,
        promoTimeText: `${this.formatDateTime(
          item.startTime
        )} 至 ${this.formatDateTime(item.endTime)}`,
        audiences,
        topTag: topLabels.join("、") || "--",
        bottomTagType,
        bottomTag: bottomLabels.join("、") || "--",
        promotionPriceText: promo.priceText,
        discountText: promo.discountText,
        // 活动销量/收入接口暂未返回
        salesCount: item.salesVolume || "-",
        salesRevenue: item.salesRevenue || "-",
        income: item.income,
        incomeText: item.income != null ? this.formatPrice(item.income) : "--",
        status,
        statusText: this.statusTextMap[status],
        createdAt: item.createAt,
        createdAtText: this.formatDateTime(item.createAt || "0") || "-",
        manualEnded: item.manualEnded || false,
        _schemes: schemes, // 保留原始方案，供复制预填
      };
    },

    clickSearch() {
      this.queryParam.pageNum = 1;
      this.queryList();
      // 查询时也同步刷新顶部「累计销量/累计收入」汇总
      this.fetchSalesStatistics();
    },

    clickReset() {
      this.queryParam = this.getDefaultQueryParam();
      this.queryList();
    },

    // 新增：跳转到会员卡促销创建页（MemberPromotionDetail.vue）
    clickCreateSale() {
      this.$router.push({
        path: "/yunying/user/member/promotionDetail",
        query: { actionType: "add" },
      });
    },

    changeCurrentPage(pageNum) {
      this.queryParam.pageNum = Number(pageNum) || 1;
      this.queryList();
    },

    // 查看促销：跳转到促销详情页（MemberPromotionDetail.vue 只读 view 模式）
    clickView(row) {
      if (!row) {
        return;
      }
      this.$router.push({
        path: "/yunying/user/member/promotionDetail",
        query: { actionType: "view", id: row.id },
      });
    },

    // 编辑：跳转到促销详情页（edit 模式，仅活动名称/顶部标签/底部标签/活动说明可改）
    clickEdit(row) {
      if (!row) {
        return;
      }
      this.$router.push({
        path: "/yunying/user/member/promotionDetail",
        query: { actionType: "edit", id: row.id },
      });
    },

    // 复制：跳转到 PRD 版促销创建页，带入被复制活动方案（copyId 预填，活动名称/时间需重填）
    clickCopy(row) {
      if (!row) {
        return;
      }
      this.$router.push({
        path: "/yunying/user/member/promotionDetail",
        query: { actionType: "add", copyId: row.id },
      });
    },

    // 立即结束：二次确认后 POST /adminapi/privilegePromotion/endNow {id}
    clickEnd(row) {
      if (!row) {
        return;
      }
      this.$confirm(
        `确定要立即结束活动「${row.activityName}」吗？结束后该活动将变为“已结束”状态。`,
        "立即结束",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$http({
            url: this.$util.domain + "/adminapi/privilegePromotion/endNow",
            method: "POST",
            body: JSON.stringify({ id: row.id }),
          })
            .then((res) => {
              const resp = res.data || res.body;
              if (resp && resp.error === 10000) {
                this.$util.successMsg("已结束");
                this.queryList();
              } else {
                this.$util.errorMsg((resp && resp.message) || "操作失败");
              }
            })
            .catch((err) => {
              this.$util.errorMsg((err && err.message) || "操作失败");
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.search-wrapper {
  margin-bottom: 8px;
}

.search-row {
  margin-bottom: 0;
}

.search-action-item {
  margin-left: 48px;
}

/* 列表上方汇总 */
.summary-wrapper {
  display: flex;
  gap: 24px;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #f5f7fa;
  border-radius: 4px;
}

.summary-item {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.summary-label {
  color: #606266;
  font-size: 14px;
}

.summary-value {
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

/* 汇总右侧新增按钮，靠右对齐 */
.summary-add-btn {
  margin-left: auto;
}

/* 适用人群逐行展示 */
.audience-line {
  line-height: 1.6;
}

.discount-text {
  margin-left: 6px;
  color: #8492a6;
  font-size: 12px;
}

/* 底部标签为活动倒计时时的读秒文案 */
.countdown-text {
  color: #f56c6c;
  font-variant-numeric: tabular-nums;
}

.unit-tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}

.audience-edit-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 20px 0;
  box-sizing: border-box;
}

.pagination-seq {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px 12px;
}
</style>



// WEBPACK FOOTER //
// MemberPromotion.vue?515b4656